import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=18176662&scoped=true"
import script from "./PasswordForm.vue?vue&type=script&lang=ts"
export * from "./PasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./PasswordForm.vue?vue&type=style&index=0&id=18176662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18176662",
  null
  
)

export default component.exports